'use client';

import React from 'react';
import { XIcon } from '@milanote/roma-icons';
import { Button as AriaButton, type ButtonProps as AriaButtonProps } from 'react-aria-components';
import { cx } from '../../../utils/cx';

const sizes = {
    xs: { root: 'size-7', icon: 'size-4' },
    sm: { root: 'size-9', icon: 'size-5' },
    md: { root: 'size-10', icon: 'size-5' },
    lg: { root: 'size-11', icon: 'size-6' },
};

export interface CloseButtonProps extends AriaButtonProps {
    size?: 'xs' | 'sm' | 'md' | 'lg';
    label?: string;
}

export const CloseButton = ({ label, className, size = 'sm', isDisabled, ...otherProps }: CloseButtonProps) => {
    return (
        <AriaButton
            {...otherProps}
            aria-label={label || 'Close'}
            isDisabled={isDisabled}
            className={(state) =>
                cx(
                    'flex cursor-pointer items-center justify-center rounded-xs p-2 transition duration-100 ease-linear',
                    'focus-visible:outline-2 focus-visible:-outline-offset-1 outline-focus-ring',
                    'text-fg-quaternary hover:bg-primary_hover hover:text-fg-quaternary_hover',
                    'disabled:cursor-not-allowed disabled:text-fg-disabled',
                    sizes[size].root,
                    typeof className === 'function' ? className(state) : className,
                )
            }
        >
            <XIcon aria-hidden="true" className={cx('shrink-0 transition-inherit-all', sizes[size].icon)} />
        </AriaButton>
    );
};
